<h4 mat-dialog-title class="mb-0">
  <div class="dialog-title">
    <span class="line-1">
      {{all_files[index].displayname || all_files[index].filename ||all_files[index].fileName }}
    </span>
    <!-- <a class="download mx-2" (click)="downloadFile(all_files[index])" matTooltip="Download" target='_self'>
      Download <i class="mx-1 fa fa-download" aria-hidden="true"></i>
    </a> -->

    <span (click)="close()" style="cursor:pointer;margin-left: auto;">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
</h4>

<div class="h-75" mat-dialog-content>
  <!-- {{all_files[index] |json}} -->
  <ng-container *ngIf="refresh">
    <ng-container
      *ngIf="decalration_documents&& decalration_documents[index].agreedStatus && all_files[index].signedurl;else normal">
      <app-ngx-dov-viewer viewer="google" [cdnPath]="all_files[index].signedurl"
        style="width: 100%;height: 100%;object-fit: contain;">
      </app-ngx-dov-viewer>
    </ng-container>
    <ng-template #normal>
      <ng-container *ngIf="!fetching_data && all_files[index].url;else noPreview">
        <app-ngx-dov-viewer viewer="google" [cdnPath]="(all_files[index].url)"
          style="width: 100%;height: 100%;object-fit: contain;">
        </app-ngx-dov-viewer>
      </ng-container>

      <ng-template #noPreview>
        <div class="d-block text-center p-5">
          {{'FILES.no_preview' | translate}}
        </div>
      </ng-template>
    </ng-template>
  </ng-container>


</div>

<mat-dialog-actions>
  <div class="row">
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>
    <div class="col-md-12 text-right mb-2">
      <!-- <span class="ml-auto"> -->
      <span class=" mr-4" *ngIf="all_files.length > 1">
        <i class="fa fa-angle-double-left prev-icon pointer" matTooltip="Previous"
          [ngClass]="{'out-of-index' : negative_index }" (click)="previousFile()" *ngIf="index != 0">
        </i>
        <span class="count mx-2"> {{(index + 1) +( ' of ' | translate) + (all_files.length)}}</span>
        <i class="fa fa-angle-double-right next-icon pointer" matTooltip=" Next"
          [ngClass]="{'out-of-bound' : index_outof_bound }" (click)="nextFile()" *ngIf="index != all_files.length -1 ">
        </i>
      </span>

      <!-- </span> -->
    </div>
    <div class="col-md-12 text-right">

      <!-- <tm-digital-signature [form_group]="form_group" [height]="120" [form_control]="'sign'"></tm-digital-signature> -->
      <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action my-auto"
        (click)="agree(decalration_documents[index])" type="submit" *ngIf="!decalration_documents[index].agreedStatus">
        {{'I agree' | translate}}
        <span class="blob-btn__inner">
          <span class="blob-btn__blobs">
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
          </span>
        </span>
      </button>

      <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action my-auto" type="submit"
        *ngIf="decalration_documents[index].agreedStatus && !disableDownload"
        (click)="download(decalration_documents[index].attachValue)">
        {{'Download signed document' | translate}}
        <span class="blob-btn__inner">
          <span class="blob-btn__blobs">
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
          </span>
        </span>

      </button>

    </div>
  </div>
</mat-dialog-actions>